import { faCircle as faCircleDoutone } from '@fortawesome/pro-duotone-svg-icons/faCircle'

export default [faCircleDoutone]
